// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2ihnW","actionsCol":"EnrolledClinics_actionsCol__3ZGhj"};